import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  NuvemEnvioSearchLabelsRequestDto,
  NuvemEnvioSearchLabelsResponseDto,
} from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import {
  getNuvemEnvioSearchLabelsData,
  getNuvemEnvioSearchLabelsStatus,
} from '../../ordersSlice/ordersSelectors';
import {
  searchForNuvemEnvioLabels as searchNuvemEnvioLabelsAction,
  resetSearchNuvemEnvioLabels as resetSearchNuvemEnvioLabelsAction,
} from '../../ordersSlice/ordersSlice';

export interface UseSearchNuvemEnvioLabelsResult {
  searchNuvemEnvioLabels: (
    params: NuvemEnvioSearchLabelsRequestDto,
  ) => Promise<NuvemEnvioSearchLabelsResponseDto>;
  data: NuvemEnvioSearchLabelsResponseDto;
  status: {
    isIdle: boolean;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
  };
  resetSearchNuvemEnvioLabels: () => void;
}

function useSearchNuvemEnvioLabels(): UseSearchNuvemEnvioLabelsResult {
  const dispatch = useAppDispatch();

  const data = useSelector(getNuvemEnvioSearchLabelsData);
  const status = useSelector(getNuvemEnvioSearchLabelsStatus);

  const searchNuvemEnvioLabels = useCallback(
    async (
      params: NuvemEnvioSearchLabelsRequestDto,
    ): Promise<NuvemEnvioSearchLabelsResponseDto> => {
      const response = await dispatch(
        searchNuvemEnvioLabelsAction(params),
      ).unwrap();

      return response;
    },
    [dispatch],
  );

  const resetSearchNuvemEnvioLabels = useCallback(() => {
    dispatch(resetSearchNuvemEnvioLabelsAction());
  }, [dispatch]);

  return {
    searchNuvemEnvioLabels,
    data,
    status,
    resetSearchNuvemEnvioLabels,
  };
}

export default useSearchNuvemEnvioLabels;
